export default __webpack_public_path__ + "static/media/link.daf09425.png";